import { render, staticRenderFns } from "./AboutDemis.vue?vue&type=template&id=50832bbe&scoped=true&"
import script from "./AboutDemis.vue?vue&type=script&lang=js&"
export * from "./AboutDemis.vue?vue&type=script&lang=js&"
import style0 from "./AboutDemis.vue?vue&type=style&index=0&id=50832bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50832bbe",
  null
  
)

export default component.exports